import { useDispatch, useSelector } from "react-redux";
import { MenuItem, Typography } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import {
  EDIT_MODE_ACTIVE_WARNING,
  MAP_EDIT_MODE_ACTIVE_WARNING,
  PLEASE_SELECT,
} from "../../consts/strings";
import {
  COLLECTIONS_PLAN_TYPE,
  NON_DELIVERY_PLAN_TYPES,
  ROBOTS_PLAN_TYPE,
  PLAN_TYPES,
  PLAN_TYPE_NAMES,
} from "../../consts/planTypes";
import { MENU_ITEM, SELECT_TYPE } from "../../consts/sentryIds";
import { palette } from "../../theme/palette";

import { addNotification, setSelectedRoute } from "../../reducers/ownApp";
import {
  setSelectedOverlay,
  setHeatmapView,
} from "../../reducers/matrixProfile";
import {
  getMatrixProfileType,
  isEditModeSelector,
} from "../../reducers/matrixProfile/selectors";
import { setMatrixProfileOptions } from "../../reducers/matrixProfile/thunkActions";
import {
  robotPlanningEnabledSelector,
  mapEditModeSelector,
} from "../../reducers/depot/selectors";

import StyledSelect from "../StyledSelect";
import { View } from "../View";

const useStyles = makeStyles({
  container: {
    marginLeft: "20px",
    alignItems: "center",
    display: "flex",
  },
  text: {
    color: palette.typography.white.high,
    fontSize: "12px",
    marginRight: "4px",
  },
  option: {
    color: palette.black,
  },
});

export const TypeSelector = () => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const robotPlanningEnabled = useSelector(robotPlanningEnabledSelector);
  const type = useSelector(getMatrixProfileType);
  const mapEditMode = useSelector(mapEditModeSelector);
  const isEditMode = useSelector(isEditModeSelector);

  const handleChange = (event) => {
    dispatch(setSelectedRoute());
    dispatch(
      setMatrixProfileOptions({ key: "type", value: event.target.value })
    );
    COLLECTIONS_PLAN_TYPE === event.target.value &&
      dispatch(setSelectedOverlay(null));
    NON_DELIVERY_PLAN_TYPES.includes(event.target.value) &&
      dispatch(setHeatmapView(false));
  };

  const validateEdit = () => {
    if (isEditMode)
      dispatch(
        addNotification({
          message: EDIT_MODE_ACTIVE_WARNING,
          options: { variant: "info" },
        })
      );
    else if (mapEditMode)
      dispatch(
        addNotification({
          message: MAP_EDIT_MODE_ACTIVE_WARNING,
          options: { variant: "info" },
        })
      );
  };

  return (
    <View className={styles.container}>
      <Typography className={styles.text}>Type:</Typography>
      <StyledSelect
        variant="standard"
        onClick={validateEdit}
        disabled={isEditMode || mapEditMode}
        value={type || ""}
        displayEmpty
        renderValue={(value) =>
          value ? PLAN_TYPE_NAMES[value] : PLEASE_SELECT
        }
        disableUnderline={true}
        onChange={handleChange}
        sentryId={SELECT_TYPE}
      >
        {PLAN_TYPES.filter((type) => {
          if (type === ROBOTS_PLAN_TYPE) return robotPlanningEnabled;
          else return true;
        }).map((item) => (
          <MenuItem
            className={styles.option}
            key={item}
            value={item}
            sentryId={`${SELECT_TYPE}__${MENU_ITEM}`}
          >
            {PLAN_TYPE_NAMES[item]}
          </MenuItem>
        ))}
      </StyledSelect>
    </View>
  );
};
